import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { getTranslation } from '../translations';
import './TopBanner.css';

const TopBanner = () => {
  const [isVisible, setIsVisible] = useState(true);
  const { language } = useLanguage();
  const t = getTranslation(language);

  const handleClose = () => {
    setIsVisible(false);
    document.body.classList.add('banner-closed');
  };

  if (!isVisible) return null;

  return (
    <div className="top-banner" style={{ color: '#FFFFFF' }}>
      <Link to="/safeclaw" className="top-banner-content" style={{ color: '#FFFFFF', textDecoration: 'none' }}>
        <span className="banner-emoji">🎉</span>
        <span className="banner-text" style={{ color: '#FFFFFF' }}>
          {t.banner.text} <strong style={{ color: '#FFFFFF' }}>{t.banner.date}</strong>
        </span>
        <span className="banner-arrow">→</span>
      </Link>
      <button 
        className="banner-close" 
        onClick={handleClose}
        aria-label="Close banner"
        style={{ color: '#FFFFFF' }}
      >
        ×
      </button>
    </div>
  );
};

export default TopBanner;
